import { mapGetters, mapActions } from 'vuex'

export default {
  data: () => ({
    loading: true,
    relationshipItems: []
  }),
  computed: {
    ...mapGetters({
      item: 'form/fields',
      relationshipItem: 'form/relationshipFields'
    }),
    isNewRelationshipItem () {
      return this.relationshipItem && this.relationshipItem.id
    },
    isUpdateForm () {
      return this.$route.name.includes('Update')
    },
    hasRelationshipItems () {
      return this.relationshipItems && this.relationshipItems.length
    }
  },
  beforeDestroy () {
    this.resetRelationship()
  },
  methods: {
    ...mapActions({
      initRelationship: 'form/initRelationship',
      resetRelationship: 'form/resetRelationship',
      init: 'form/init'
    }),
    async init () {
      this.resetRelationShipItem()

      await this.loadRelationshipItems()
    },
    async resetRelationShipItem () {
      this.initRelationship({ ...JSON.parse(JSON.stringify(this.model)), ...{ [this.relationshipField]: this.item.id } })
    },
    async loadRelationshipItems () {
      try {
        let response = null

        response = await this.api.all({ [this.relationshipField]: this.item.id, sort: 'id,desc' })

        this.loading = false
        
        if (response && response.data && response.data.list) {
          this.relationshipItems = response.data.list

        } else {
          this.$toasted.error(this.$t('messages.unknown_error'))
        }

      } catch (e) {
        this.loading = false
        console.error(e)
      }
    },
    async addRelationshipItem () {
      try {

        const response = await this.api[this.isNewRelationshipItem ? 'update' : 'create'](this.relationshipItem)
        let item = this.$t('messages.item')
        
        if (response && response.data) {
          if (response.data[this.relationshipTitle]) {
            item = this.locales
              ? response.data[this.relationshipTitle].pt
              : response.data[this.relationshipTitle]
          }

          this.$toasted.success(this.$t(this.isUpdateForm ? 'messages.updated' : 'messages.created', { item: item }))

          await this.resetRelationShipItem()
          await this.loadRelationshipItems()
        } else if (response && response.response && response.response.data && response.response.data.errors) {
          this.$toasted.error(Object.values(response.response.data.errors).join(' '))
          return [Object.values(response.response.data.errors).join(' ')]
        } else {
          this.$toasted.error(this.$t('messages.unknown_error'))
          return [this.$t('messages.unknown_error')]
        }

      } catch (e) {
        console.error(e)
      }

      return []
    },
    async removeRelationshipItem (id) {
      try {
        const response = await this.api.delete(id)
        if (response.data) {
          this.$toasted.success(this.$t('messages.deleted'))
          this.loadRelationshipItems()
        }
      } catch (e) {
        console.error(e)
      }
    },
    async initRelationshipFromSpecificField(id, field) {
      const item = this.relationshipItems.find(item => item[field] === id)

      if(item) {
        this.initRelationship(item)
      }
    },
    async openEditModal (id) {
      const item = this.relationshipItems.find(item => item.id === id)

      if (item) {
        this.initRelationship(item)
        this.$refs['edit-modal'].show()
      }
    }
  }
}